import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
  {
    path: '/reserve/:activity_id'
    , name: 'reserveIndex'
    , meta: {title: '预约参观'}
    , component: () => import('../views/reserve/index.vue')
  }
  ,{
    path: '/reserve/:activity_id/register/start'
    , name: 'reserveRegisterStart'
    , meta: {title: '预约登记'}
    , component: () => import('../views/reserve/registerStart.vue')
  }
  ,{
    path: '/reserve/:activity_id/register/member/:activity_time_id/:activity_date'
    , name: 'reserveRegisterMember'
    , meta: {title: '成员登记'}
    , component: () => import('../views/reserve/registerMember.vue')
  }
  ,{
    path: '/reserve/:activity_id/register/edit/member/:activity_record_id'
    , name: 'reserveRegisterMemberEdit'
    , meta: {title: '修改成员登记'}
    , component: () => import('../views/reserve/registerMember.vue')
  }
  ,{
    path: '/reserve/:activity_id/register/result'
    , name: 'reserveRegisterResult'
    , meta: {title: '预约成功'}
    , component: () => import('../views/reserve/registerResult.vue')
  }
  ,{
    path: '/reserve/:activity_id/record'
    , name: 'reserveRecord'
    , meta: {title: '预约记录'}
    , component: () => import('../views/reserve/record.vue')
  }
  ,{
    path: '/reserve/:activity_id/record/details/:activity_record_id'
    , name: 'reserveRecordDetails'
    , meta: {title: '预约详情'}
    , component: () => import('../views/reserve/recordDetails.vue')
  }
  ,{
    path: '/reserve/:activity_id/check'
    , name: 'reserveCheck'
    , meta: {title: '入口检测'}
    , component: () => import('../views/reserve/check.vue')
  }
  // 404页
  ,{
    path: '/403'
    , name: '403'
    , meta: {title: '403'}
    , component: () => import('../views/other/403.vue')
  }
  // 404页
  ,{
    path: '*'
    , name: 'code404'
    , meta: {title: '404'}
    , component: () => import('../views/other/404.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  // base: "/h5",
  routes
});

router.beforeEach((to
    , from
    , next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }else{
    document.title = '互联网医院';
  }
  next();
});

export default router
